import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import DocumentDetailsComponent from '../components/DocumentDetailsComponent';
import withFmsLayout from '../layout/withFmsLayout';


function DocumentDetailsPage() {
  const {documentId} = useParams();
  
  return(
    <DocumentDetailsComponent documentId={documentId} />
  )
  
}

export default withFmsLayout(DocumentDetailsPage)